import { render } from "./DataSeragam.vue?vue&type=template&id=0186d088"
import script from "./DataSeragam.vue?vue&type=script&lang=js"
export * from "./DataSeragam.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__